export const SuperAdminPolicy = ['SuperAdmin'];
export const AdminPolicy = ['SuperAdmin', 'Admin'];
export const ContactPersonPolicy = ['SuperAdmin', 'Admin', 'ContactPerson'];
